var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding03White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790 527.879H10V564.326H790V527.879Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M716.551 264.505H83.4492V527.873H716.551V264.505Z",
    fill: "#c9c9c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M735.304 259.185H64.6895L98.1755 175.375H701.818L735.304 259.185Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M735.304 259.185H64.6895L98.1755 175.375H701.818L735.304 259.185Z",
    fill: "black",
    fillOpacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.819 392.099H141.078V527.862H213.819V392.099Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.24 404.864H155.656V464.09H199.24V404.864Z",
    fill: "#c9c9c9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M695.856 258.551H656.408H616.96H577.512H538.064H498.616H459.169H419.72H380.273H340.824H301.377H261.929H222.481H183.033H143.585H104.137H64.6895V326.544C64.6895 337.437 73.5202 346.268 84.4133 346.268C95.3063 346.268 104.137 337.437 104.137 326.544C104.137 337.437 112.968 346.268 123.861 346.268C134.755 346.268 143.585 337.437 143.585 326.544C143.585 337.437 152.416 346.268 163.309 346.268C174.202 346.268 183.033 337.437 183.033 326.544C183.033 337.437 191.864 346.268 202.757 346.268C213.65 346.268 222.481 337.437 222.481 326.544C222.481 337.437 231.312 346.268 242.205 346.268C253.098 346.268 261.929 337.437 261.929 326.544C261.929 337.437 270.759 346.268 281.653 346.268C292.546 346.268 301.377 337.437 301.377 326.544C301.377 337.437 310.207 346.268 321.101 346.268C331.994 346.268 340.824 337.437 340.824 326.544C340.824 337.437 349.655 346.268 360.549 346.268C371.442 346.268 380.273 337.437 380.273 326.544C380.273 337.437 389.103 346.268 399.997 346.268C410.89 346.268 419.72 337.437 419.72 326.544C419.72 337.437 428.551 346.268 439.444 346.268C450.338 346.268 459.169 337.437 459.169 326.544C459.169 337.437 467.999 346.268 478.892 346.268C489.785 346.268 498.616 337.437 498.616 326.544C498.616 337.437 507.447 346.268 518.34 346.268C529.234 346.268 538.064 337.437 538.064 326.544C538.064 337.437 546.895 346.268 557.788 346.268C568.681 346.268 577.512 337.437 577.512 326.544C577.512 337.437 586.343 346.268 597.236 346.268C608.129 346.268 616.96 337.437 616.96 326.544C616.96 337.437 625.791 346.268 636.684 346.268C647.577 346.268 656.408 337.437 656.408 326.544C656.408 337.437 665.238 346.268 676.132 346.268C687.025 346.268 695.856 337.437 695.856 326.544C695.856 337.437 704.687 346.268 715.58 346.268C726.473 346.268 735.304 337.437 735.304 326.544V258.551H695.856Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M654.215 84.9907H145.787V175.38H654.215V84.9907Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M698.631 147.607H101.365V175.377H698.631V147.607Z",
    fill: "#c9c9c9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.977 147.604V175.374H100.977V147.604H102.977Z",
    fill: "#ffffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.818 147.604V175.374H124.818V147.604H126.818Z",
    fill: "#ffffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.658 147.604V175.374H148.658V147.604H150.658Z",
    fill: "#ffffff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.502 147.604V175.374H172.502V147.604H174.502Z",
    fill: "#ffffff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.344 147.604V175.374H196.344V147.604H198.344Z",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.188 147.604V175.374H220.188V147.604H222.188Z",
    fill: "#ffffff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.027 147.604V175.374H244.027V147.604H246.027Z",
    fill: "#ffffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.869 147.604V175.374H267.869V147.604H269.869Z",
    fill: "#ffffff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.713 147.604V175.374H291.713V147.604H293.713Z",
    fill: "#ffffff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.555 147.604V175.374H315.555V147.604H317.555Z",
    fill: "#ffffff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.395 147.604V175.374H339.395V147.604H341.395Z",
    fill: "#ffffff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.238 147.604V175.374H363.238V147.604H365.238Z",
    fill: "#ffffff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.08 147.604V175.374H387.08V147.604H389.08Z",
    fill: "#ffffff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.92 147.604V175.374H410.92V147.604H412.92Z",
    fill: "#ffffff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.764 147.604V175.374H434.764V147.604H436.764Z",
    fill: "#ffffff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.605 147.604V175.374H458.605V147.604H460.605Z",
    fill: "#ffffff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.449 147.604V175.374H482.449V147.604H484.449Z",
    fill: "#ffffff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.291 147.604V175.374H506.291V147.604H508.291Z",
    fill: "#ffffff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.131 147.604V175.374H530.131V147.604H532.131Z",
    fill: "#ffffff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.975 147.604V175.374H553.975V147.604H555.975Z",
    fill: "#ffffff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.816 147.604V175.374H577.816V147.604H579.816Z",
    fill: "#ffffff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.66 147.604V175.374H601.66V147.604H603.66Z",
    fill: "#ffffff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.502 147.604V175.374H625.502V147.604H627.502Z",
    fill: "#ffffff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.342 147.604V175.374H649.342V147.604H651.342Z",
    fill: "#ffffff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.184 147.604V175.374H673.184V147.604H675.184Z",
    fill: "#ffffff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.023 147.604V175.374H697.023V147.604H699.023Z",
    fill: "#ffffff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.455 391.458C131.455 389.875 132.738 388.593 134.32 388.593H220.577C222.159 388.593 223.442 389.875 223.442 391.458C223.442 393.04 222.159 394.323 220.577 394.323H134.32C132.738 394.323 131.455 393.04 131.455 391.458Z",
    fill: "#ffffff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M665.662 390.804H269.998V459.991H665.662V390.804Z",
    fill: "#ffffff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.354 459.983C256.354 459.431 256.801 458.983 257.354 458.983H678.31C678.862 458.983 679.31 459.431 679.31 459.983C679.31 460.535 678.862 460.983 678.31 460.983H257.354C256.801 460.983 256.354 460.535 256.354 459.983Z",
    fill: "#ffffff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.354 390.798C256.354 390.246 256.801 389.798 257.354 389.798H678.31C678.862 389.798 679.31 390.246 679.31 390.798C679.31 391.35 678.862 391.798 678.31 391.798H257.354C256.801 391.798 256.354 391.35 256.354 390.798Z",
    fill: "#ffffff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M236.217 519.064H118.678V527.872H236.217V519.064Z",
    fill: "#ffffff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M708.786 163.208L584.001 110.705C574.788 106.828 569.158 99.3174 574.611 86.3573C580.064 73.3973 589.37 72.1705 598.583 76.0466L723.368 128.55C732.58 132.426 738.21 139.937 732.757 152.897C727.305 165.857 717.998 167.084 708.786 163.208Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M734.922 134.739L586.082 72.114L586.082 72.1139C594.706 51.6165 617.498 41.6482 636.989 49.8491L715.246 82.7755C734.737 90.9764 743.547 114.241 734.922 134.739L734.922 134.739Z",
    fill: "#bebebe"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M643.606 68.7663C645.182 69.4296 647.058 68.5456 647.796 66.7919C648.534 65.0383 647.854 63.079 646.278 62.4157C644.702 61.7525 642.826 62.6365 642.088 64.3901C641.35 66.1438 642.03 68.1031 643.606 68.7663Z",
    fill: "#ffffff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M612.016 72.6413C613.593 73.3046 615.469 72.4206 616.206 70.6669C616.944 68.9133 616.265 66.954 614.688 66.2907C613.112 65.6275 611.236 66.5115 610.498 68.2651C609.76 70.0188 610.44 71.9781 612.016 72.6413Z",
    fill: "#ffffff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M690.626 88.549C692.202 89.2123 694.078 88.3283 694.816 86.5747C695.554 84.821 694.874 82.8617 693.298 82.1985C691.721 81.5352 689.845 82.4192 689.107 84.1729C688.37 85.9265 689.049 87.8858 690.626 88.549Z",
    fill: "#ffffff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M654.891 90.3269C656.468 90.9901 658.344 90.1062 659.081 88.3525C659.819 86.5988 659.14 84.6395 657.563 83.9763C655.987 83.3131 654.111 84.197 653.373 85.9507C652.635 87.7043 653.315 89.6636 654.891 90.3269Z",
    fill: "#ffffff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M724.756 102.91C726.333 103.573 728.209 102.689 728.947 100.935C729.684 99.1818 729.005 97.2225 727.428 96.5593C725.852 95.8961 723.976 96.78 723.238 98.5337C722.5 100.287 723.18 102.247 724.756 102.91Z",
    fill: "#ffffff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M706.768 111.554C708.344 112.218 710.221 111.334 710.958 109.58C711.696 107.826 711.016 105.867 709.44 105.204C707.864 104.541 705.988 105.425 705.25 107.178C704.512 108.932 705.192 110.891 706.768 111.554Z",
    fill: "#ffffff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M725.936 163.426L571.85 98.5938L571.85 98.5938C561.988 122.032 574.243 138.666 594.421 147.156L675.436 181.243C695.614 189.733 716.074 186.864 725.936 163.426L725.936 163.426Z",
    fill: "#bebebe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding03White);
export default __webpack_public_path__ + "static/media/building-03-white.0251c1603a31cc2b118e3da7eca124ca.svg";
export { ForwardRef as ReactComponent };